module.exports = __webpack_public_path__ + "bd486a6dc5c77592c8f2717262d6f7f7.pdf";